import hr15 from "./hr15"
import Employeerole from "./Employeerole";

export default {
    hr15,
 ...Employeerole
}